import {connect} from 'react-redux';
import {IceBucket as Component} from './IceBucket';
import {
  createIceBucket,
  setHeldObject,
  setSolutionHeld,
  setShowSolutionContents,
  hideAllControls,
  setSolutionControlVisibility,
  setMoveMenu,
  showMoveMenu
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("iceBuckets") &&
     state.notebook.protocolSection.scene.apparatus.iceBuckets.some(
       iceBucket => iceBucket.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.iceBuckets[ownProps.id-1].type,
      solutions: state.notebook.protocolSection.scene.apparatus.iceBuckets[ownProps.id-1].solutions,
      labelReactionTubes: state.notebook.protocolSection.scene.labelReactionTubes,
      //showSolutionContents: state.notebook.protocolSection.scene.apparatus.iceBuckets[ownProps.id-1].solutions[ownProps.id - 1].showSolutionContents,
      //controlsVisible: state.notebook.protocolSection.scene.apparatus.iceBuckets[ownProps.id-1].solutions[ownProps.id - 1].controlsVisible,


      interactionProps: {
        solutions: state.notebook.protocolSection.scene.apparatus.solutions
      }
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createIceBucket: (data)=>{
      dispatch(createIceBucket(data))
    },
    setSolutionHeld: (data) => {
      dispatch(setSolutionHeld(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    setShowSolutionContents: (data) => {
      dispatch(setShowSolutionContents(data))
    },
    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },
    setSolutionControlVisibility: (data) => {
      dispatch(setSolutionControlVisibility(data))
    },
    setMoveMenu: (data) => {
      dispatch(setMoveMenu(data))
    },
    showMoveMenu: (data) => {
      dispatch(showMoveMenu(data))
    }
  };
}

export const IceBucket = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
